import { Signage } from '../../Signage';
import { ReachAPI } from '../../ReachApi';
import { moment } from '../../../vendor/moment';

/* global REACH */

var shouldCameraBeOn = function (turnOnAt, turnOffAt) {
    if (turnOnAt == undefined || turnOffAt == undefined) {
        return true;
    }

    var now = moment();

    var turnOnAtToks = turnOnAt.split(':');
    var onAtDate = moment().hours(turnOnAtToks[0]).minutes(turnOnAtToks[1]);

    var turnOffAtToks = turnOffAt.split(':');
    var offAtDate = moment().hours(turnOffAtToks[0]).minute(turnOffAtToks[1]);

    // explicit on time trumps off time when the on time is after the on time
    var shouldBeOn =
        now.isSameOrAfter(onAtDate) && (now.isBefore(offAtDate) || onAtDate.isAfter(offAtDate));

    return shouldBeOn;
};

var widgetBounds;
var cameraOn = false;
var serverConfigNameCache;
var cameraNamesCache;
var turnOnAtCahce;
var turnOffAtCache;
var camerTimerOn = false;
var cameraServer;
var cameraUsername;
var cameraPassword;
var failed;

/**
 * Tell the Signage to draw an ExacqVision element (done in the C# side) based
 * on the serverConfigName and cameraNames
 * @param {HTMLElement} loadingEle the native html element being used to display
 * the loading and error text (will write to this element)
 * @param {string} serverConfigName the serverConfigName in REACH's CMS
 * @param {string[]} cameraNames the ExacqVision-given names of the cameras that
 * you want to display
 * @param {string} turnOnAt describes the time of day when the camera will be
 * visible at. Time needs to be in the form of hours:minutes (eg 18:30)
 * @param {string} turnOffAt describes the time of day when the camera will be
 * invisible at. Time needs to be in the form of hours:minutes (eg 18:30)
 * @return {undefined}
 */
export function displayCameras(loadingEle, serverConfigName, cameraNames, turnOnAt, turnOffAt) {
    if (typeof REACH !== 'undefined' && REACH.ExacqVision) {
        loadingEle.innerHTML = 'Loading...';

        failed = function (extraErrorInfo) {
            loadingEle.innerHTML = 'Failed to connect to camera. ' + extraErrorInfo;
            loadingEle.style.display = ''; // may have been hidden earlier
        };

        var setCameraState = function () {
            var shouldBeOn = shouldCameraBeOn(turnOnAtCahce, turnOffAtCache);

            if (!shouldBeOn) {
                loadingEle.innerHTML = '';
                loadingEle.style.display = 'none';
            }

            if (shouldBeOn != cameraOn) {
                // state changed. toggle the state of the camera
                cameraOn = shouldBeOn;
                if (shouldBeOn) {
                    var serverLoggedIn = REACH.ExacqVision.AddServerLoginInfo(
                        serverConfigNameCache,
                        cameraServer,
                        cameraUsername,
                        cameraPassword
                    );

                    if (serverLoggedIn) {
                        REACH.ExacqVision.RenderCamerasInView(
                            serverConfigNameCache,
                            cameraNamesCache,
                            Math.round(widgetBounds.left),
                            Math.round(widgetBounds.top),
                            Math.round(widgetBounds.width),
                            Math.round(widgetBounds.height)
                        );
                    } else {
                        failed('Failed to login to server "' + serverConfigName + '".');
                    }
                } else {
                    REACH.ExacqVision.DestroyCameraElements();
                }
            }
        };

        // let the UI update with the loading text
        setTimeout(function () {
            ReachAPI.player
                .getExacqVisionServers(Signage.playerUuid)
                .done(function (data) {
                    if (data.data && data.data.length > 0) {
                        var server = null;
                        for (var i in data.data) {
                            if (data.data[i].configuration_name == serverConfigName) {
                                server = data.data[i];
                            }
                        }

                        if (server) {
                            widgetBounds =
                                loadingEle.parentElement.parentElement.getBoundingClientRect();

                            // save vars for setInterval to work later on
                            serverConfigNameCache = serverConfigName;
                            cameraNamesCache = cameraNames;
                            turnOnAtCahce = turnOnAt;
                            turnOffAtCache = turnOffAt;
                            cameraServer = server.server;
                            cameraUsername = server.username;
                            cameraPassword = server.password;

                            cameraOn = false;
                            setCameraState();

                            if (!camerTimerOn) {
                                camerTimerOn = true;
                                setInterval(setCameraState, 60 * 1000);
                            }
                        } else {
                            failed('Server "' + serverConfigName + '" not found.');
                        }
                    } else {
                        failed('Error connecting to Reach Servers');
                    }
                })
                .fail(function () {
                    failed('Error connecting to Reach Servers');
                });
        }, 50);
    }
}
